import { UserData } from "../api/userApi";
import React from "react";

export const UserDataContext = React.createContext<UserData | undefined>(undefined);

export type UserDataProviderProps = {
	children: React.ReactNode;
	userData: UserData;
};

export function UserDataProvider({ children, userData }: UserDataProviderProps) {
	return <UserDataContext.Provider value={userData}>{children}</UserDataContext.Provider>;
}
